import Action from "../actions";

export function authReducer(
    state = localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) :
        {
            locale: 'vn',
            userData: {},
            token: '',
            isAuthorized: false
        }, action) {
    if (action.type === Action.AUTHENTICATION) {
        return action.authData;
    }
    if (action.type === Action.UNAUTHORIZED) {
        return action.authData;
    }
    return state;
}
